(() => {
  const KEY = "hoe_wishlist_v1";

  // ---------- Storage ----------
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  };

  const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

  const updateCartBubble = (count) => {
    document.querySelectorAll(".cart-bubble__text").forEach((el) => {
      el.textContent = count;
    });

    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = count;
    });

    const cartLink = document.querySelector(
      ".action__cart, .header-actions__action.action__cart"
    );
    if (cartLink) {
      cartLink.setAttribute("aria-label", `Cart: ${count}`);
    }
  };

  const refreshCartUI = async () => {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      updateCartBubble(cart.item_count);

      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: cart })
      );
    } catch (e) {
      console.warn("Cart refresh failed", e);
    }
  };

  const getHandle = (btn) => String(btn.getAttribute("data-product-handle") || "").trim();

  const has = (handle) => read().includes(handle);

  const toggle = (handle) => {
    const list = read();
    const next = list.includes(handle)
      ? list.filter((h) => h !== handle)
      : [...list, handle];

    write(next);
    return next;
  };

  // ---------- UI helpers ----------
  const setBtnState = (btn, active) => {
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-label", active ? "Remove from wishlist" : "Add to wishlist");
  };

  const updateBadge = () => {
    const count = read().length;
    document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
      el.textContent = count;
      el.classList.toggle("is-hidden", count === 0);
    });
  };

  const refreshAll = () => {
    const list = read();
    document
      .querySelectorAll("[data-wishlist-btn][data-product-handle]")
      .forEach((btn) => {
        const handle = getHandle(btn);
        if (!handle) return;
        setBtnState(btn, list.includes(handle));
      });

    updateBadge();
  };

  const initButtons = () => refreshAll();

  // ---------- Click handling (one listener, no nesting) ----------
 // ---------- Click handling (one listener, handles BOTH wishlist + add-to-cart) ----------
document.addEventListener("click", async (e) => {
  // 1) Add to cart from wishlist drawer/page
  const addBtn = e.target.closest("[data-add-to-cart]");
  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();

    const hasVariants = addBtn.dataset.hasVariants === "true";
    const handle = addBtn.dataset.handle;

    // Multi-variant → modal + redirect
    if (hasVariants) {
      showChooseVariantModal(handle);
      return;
    }

    // Single variant → add directly
    const variantId = addBtn.getAttribute("data-variant-id");
    if (!variantId) return;

    addBtn.disabled = true;
    const oldText = addBtn.textContent;
    addBtn.textContent = "Adding…";

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      await refreshCartUI();

      addBtn.textContent = "Added ✓";
      addBtn.classList.add("is-added");

      // OPTIONAL: if you want, you can auto-close wishlist drawer here:
      // document.querySelector("[data-wishlist-drawer]")?.setAttribute("hidden", "true");

    } catch (err) {
      addBtn.textContent = "Error";
      addBtn.disabled = false;
      setTimeout(() => (addBtn.textContent = oldText), 1200);
    }

    return;
  }

  // 2) Wishlist toggle/remove (heart buttons + Remove button)
  const wishBtn = e.target.closest("[data-wishlist-btn][data-product-handle]");
  if (wishBtn) {
    e.preventDefault();

    const handle = getHandle(wishBtn);
    if (!handle) return;

    toggle(handle);
    refreshAll();
    renderWishlistPage(); // keeps drawer/page in sync
    return;
  }
});




  // ---------- Wishlist page renderer (optional) ----------
const renderWishlistPage = async () => {
  // Works for BOTH:
  // 1) wishlist page section (if you keep [data-wishlist-page])
  // 2) wishlist drawer (uses direct selectors)
  const root = document.querySelector("[data-wishlist-page]");
  const empty = root ? root.querySelector("[data-wishlist-empty]") : document.querySelector("[data-wishlist-empty]");
  const grid  = root ? root.querySelector("[data-wishlist-grid]")  : document.querySelector("[data-wishlist-grid]");

  if (!empty || !grid) return;

    const handles = [...new Set(read())];
if (!handles.length) {
  if (empty) empty.hidden = false;
  if (grid) grid.innerHTML = "";
  return;
} else {
  if (empty) empty.hidden = true;
}
    if (!grid) return;

    grid.innerHTML = "<p>Loading…</p>";

    const products = await Promise.all(
      handles.map(async (h) => {
        try {
          const r = await fetch(`/products/${h}.js`);
          if (!r.ok) return null;
          return await r.json();
        } catch {
          return null;
        }
      })
    );

    const items = products.filter(Boolean);

   if (!items.length) {
  if (empty) empty.hidden = false;
  grid.innerHTML = "";
  return;
}


    grid.innerHTML = items
  .map((p) => {
    const price = (p.price / 100).toLocaleString(undefined, {
      style: "currency",
      currency: p.currency || "INR",
    });

    const img = (p.featured_image || "").replace(
      /(\.(jpg|png|webp|jpeg)).*$/i,
      "$1"
    );

    // 🔥 ADD THIS LINE
    const hasVariants = p.variants && p.variants.length > 1;

    return `
  <div class="wishlist-drawer-item">
    <div class="wishlist-drawer-item__media">
      <a href="${p.url}">
        ${img ? `<img src="${img}" alt="${p.title}" />` : ""}
      </a>
    </div>

    <div class="wishlist-drawer-item__info">
      <a href="${p.url}" class="wishlist-drawer-item__title">
        ${p.title}
      </a>

      <div class="wishlist-drawer-item__price">${price}</div>

      <!-- ADD TO CART -->
      <button
        class="button button--primary wishlist-add-to-cart"
        data-add-to-cart
        data-handle="${p.handle}"
        data-has-variants="${hasVariants}"
        ${hasVariants ? "" : `data-variant-id="${p.variants[0].id}"`}
      >
        Add to cart
      </button>

      <!-- REMOVE -->
      <button
        class="button button--secondary wishlist-remove"
        type="button"
        data-wishlist-btn
        data-product-handle="${p.handle}"
      >
        Remove
      </button>
    </div>
  </div>
`;
  })
  .join("");

    refreshAll();
  };

  // ---------- Boot ----------
 document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  renderWishlistPage();

  // ------------------------------
  // Wishlist Drawer Open / Close
  // ------------------------------
  const drawer = document.querySelector("[data-wishlist-drawer]");
  const openBtn = document.querySelector("[data-wishlist-open]");
  const closeBtns = document.querySelectorAll("[data-wishlist-close]");

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    renderWishlistPage(); // always refresh drawer content
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
  };

  openBtn?.addEventListener("click", openDrawer);
  closeBtns.forEach((btn) => btn.addEventListener("click", closeDrawer));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });
});


  // In case Shopify re-renders sections via theme editor / AJAX
  document.addEventListener("shopify:section:load", () => {
    initButtons();
    renderWishlistPage();
  });
  function showChooseVariantModal(handle) {
  // remove existing modal if any
  document.querySelector("#wishlist-variant-modal")?.remove();

  const modal = document.createElement("div");
  modal.id = "wishlist-variant-modal";
  modal.innerHTML = `
    <div class="wvm-backdrop"></div>
    <div class="wvm-box" role="dialog" aria-modal="true">
      <div class="wvm-text">Please choose a size/variant before adding to cart.</div>
      <div class="wvm-actions">
        <button class="wvm-close" type="button">Close</button>
        <a class="wvm-go button" href="/products/${handle}">Choose Variant</a>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const close = () => modal.remove();
  modal.querySelector(".wvm-backdrop").addEventListener("click", close);
  modal.querySelector(".wvm-close").addEventListener("click", close);
}
})();



